import axios from 'axios'
import constants from '../constants'

const MEMBERS_PATH = `${constants.urlPrefix}/api/members`;

const getMemberColors = function (memberId) {
    return axios.get(`${MEMBERS_PATH}/${memberId}/colors`);
};

export default {
    getMemberColors
}
